import { createQuiz } from "@/components/quizEngine";

const traits = ["kind", "clever", "bold", "proud", "elegant", "cheerful", "mysterious", "loyal", "fierce"];

const bank = [
  ["You wake up in someone else's body. You…", [
    ["Smile. A healthy body? How fun!", { cheerful: 3, bold: 1 }],
    ["Make a careful plan to switch back", { clever: 2 }],
    ["Get very, very angry", { fierce: 2, proud: 1 }],
    ["Keep it secret and watch everyone", { mysterious: 2 }],
  ]],
  ["Someone spreads a cruel rumor about your friend. You…", [
    ["Defend them in front of everyone", { loyal: 3 }],
    ["Find out who started it", { clever: 2, mysterious: 1 }],
    ["Get revenge, elegantly", { fierce: 2, elegant: 1 }],
    ["Comfort your friend first", { kind: 3 }],
  ]],
  ["Your favorite palace hobby:", [
    ["Dancing", { elegant: 3 }],
    ["Archery", { bold: 2, fierce: 1 }],
    ["Painting and poetry", { elegant: 1, proud: 1, clever: 1 }],
    ["Gardening, even in the dungeon", { cheerful: 2, kind: 1 }],
  ]],
  ["Which flower suits you?", [
    ["A butterfly-loved peony", { elegant: 2, proud: 1 }],
    ["A wild weed that grows anywhere", { cheerful: 2, bold: 1 }],
    ["A blue orchid with hidden thorns", { mysterious: 2, clever: 1 }],
    ["A plum blossom in the snow", { loyal: 2, kind: 1 }],
  ]],
  ["You're thrown in a dungeon. You…", [
    ["Grow vegetables and make friends", { cheerful: 3, kind: 1 }],
    ["Plot your escape", { clever: 2, bold: 1 }],
    ["Demand to see the prince", { proud: 2, fierce: 1 }],
    ["Wait quietly. Your time will come", { mysterious: 2 }],
  ]],
  ["What do people misunderstand about you?", [
    ["I'm not as fragile as I look", { bold: 2, fierce: 1 }],
    ["I'm not as mean as I act", { kind: 1, proud: 1, loyal: 1 }],
    ["I'm not as sweet as I seem", { mysterious: 2, clever: 1 }],
    ["I'm not as cold as I look", { loyal: 2, elegant: 1 }],
  ]],
  ["Your role at the tea party:", [
    ["Graceful host", { elegant: 2, kind: 1 }],
    ["Quiet observer reading everyone", { clever: 2, mysterious: 1 }],
    ["The one who says what everyone thinks", { fierce: 2, bold: 1 }],
    ["Cheerful guest eating all the snacks", { cheerful: 2 }],
  ]],
  ["A rival challenges you. You…", [
    ["Accept with a smile", { cheerful: 1, bold: 2 }],
    ["Win with skill and style", { elegant: 1, proud: 2 }],
    ["Out-think them", { clever: 3 }],
    ["Try to become friends instead", { kind: 3 }],
  ]],
  ["Pick a court treasure:", [
    ["A silk fan", { elegant: 2 }],
    ["A bow and arrows", { bold: 2 }],
    ["A book of forbidden Taoist magic", { mysterious: 2, fierce: 1 }],
    ["A friend's handwritten letter", { loyal: 2, kind: 1 }],
  ]],
  ["How do you handle being sick?", [
    ["Keep smiling and pretend I'm fine", { cheerful: 2, bold: 1 }],
    ["Complain loudly", { proud: 1, fierce: 1 }],
    ["Read books in bed", { clever: 2 }],
    ["Take care of someone else anyway", { kind: 2, loyal: 1 }],
  ]],
  ["Your guard is your…", [
    ["Best friend", { loyal: 2, kind: 1 }],
    ["Secret crush", { mysterious: 1, elegant: 1 }],
    ["Training partner", { bold: 2 }],
    ["Audience for my rants", { fierce: 1, cheerful: 1 }],
  ]],
  ["What makes you jealous?", [
    ["Nothing. I'm happy for others", { kind: 2, cheerful: 1 }],
    ["Someone more beautiful", { proud: 2, elegant: 1 }],
    ["Someone more loved", { fierce: 2 }],
    ["Someone smarter", { clever: 2 }],
  ]],
  ["Pick a color for your robes:", [
    ["Gold and yellow", { cheerful: 1, kind: 1 }],
    ["Deep red", { fierce: 2, proud: 1 }],
    ["Soft blue", { mysterious: 1, clever: 1 }],
    ["Black and silver", { elegant: 1, loyal: 1, bold: 1 }],
  ]],
  ["The prince ignores you. You…", [
    ["Don't care, I have chickens to feed", { cheerful: 2, bold: 1 }],
    ["Feel hurt but hold my head high", { proud: 2 }],
    ["Make him notice me", { fierce: 2 }],
    ["Focus on helping my friends", { loyal: 2, kind: 1 }],
  ]],
  ["Your secret talent:", [
    ["Surviving anything", { bold: 2, cheerful: 1 }],
    ["Reading people", { clever: 2, mysterious: 1 }],
    ["Making curses (oops)", { mysterious: 2, fierce: 1 }],
    ["Cheering people up", { cheerful: 2, kind: 1 }],
  ]],
  ["A festival is coming. You…", [
    ["Practice the dance all night", { elegant: 2, proud: 1 }],
    ["Make sure nobody sabotages it", { clever: 1, loyal: 1 }],
    ["Plan a surprise", { mysterious: 1, cheerful: 1 }],
    ["Sneak out to eat street food", { bold: 2 }],
  ]],
  ["Someone apologizes for hurting you. You…", [
    ["Forgive them right away", { kind: 3 }],
    ["Forgive, but remember", { clever: 1, mysterious: 1 }],
    ["Make them earn it", { proud: 2 }],
    ["Say \"Fine\" but secretly cry", { fierce: 1, loyal: 1 }],
  ]],
  ["Your animal spirit:", [
    ["Butterfly", { elegant: 2, kind: 1 }],
    ["Rat, and proud of it", { fierce: 1, bold: 1, proud: 1 }],
    ["Squirrel, cute but dangerous", { mysterious: 2, clever: 1 }],
    ["Eagle", { loyal: 1, bold: 2 }],
  ]],
  ["You get a chance to become empress. You…", [
    ["Only if my friends are safe", { loyal: 2, kind: 1 }],
    ["Of course, I deserve it", { proud: 3 }],
    ["Only after I outsmart everyone", { clever: 2 }],
    ["Honestly? I'd rather be healthy", { cheerful: 2 }],
  ]],
  ["Your best friend is your…", [
    ["Opposite in every way", { cheerful: 1, fierce: 1 }],
    ["Old enemy", { proud: 1, kind: 1 }],
    ["Loyal attendant", { loyal: 2 }],
    ["Rival who keeps me sharp", { clever: 1, bold: 1 }],
  ]],
  ["What is real strength?", [
    ["A kind heart", { kind: 3 }],
    ["Never giving up", { bold: 2, cheerful: 1 }],
    ["Protecting your people", { loyal: 3 }],
    ["Knowing your own worth", { proud: 2, elegant: 1 }],
  ]],
];

const characters = [
  { name: "Kou Reirin", title: "The court butterfly", text: "Graceful, kind and secretly unstoppable. Give you a healthy body and a dungeon, and you'll grow a garden.", traits: { kind: 2, cheerful: 2, bold: 1, elegant: 1 }, colors: ["#ffd166", "#fff8e7", "#f7b2c8"], image: "/img/iv/reirin.jpg" },
  { name: "Shu Keigetsu", title: "The court rat", text: "Sharp-tongued and fiery, but loyal to the bone once someone truly sees you.", traits: { fierce: 3, proud: 1, loyal: 1, mysterious: 1 }, colors: ["#c1121f", "#1b1b1f", "#e9b949"], image: "/img/iv/keigetsu.jpg" },
  { name: "Kin Seika", title: "Maiden of the Kin clan", text: "You love beauty and art, and you're much softer than your proud face lets on.", traits: { elegant: 2, proud: 2, kind: 1 }, colors: ["#e9b949", "#f7b2c8", "#fff8e7"], image: "/img/iv/seika.jpg" },
  { name: "Ran Houshun", title: "Maiden of the Ran clan", text: "Small, sweet-looking and brilliant at strategy. Never underestimate you.", traits: { clever: 3, mysterious: 2 }, colors: ["#3a86ff", "#a0d2ff", "#fff8e7"] },
  { name: "Gen Kasui", title: "Maiden of the Gen clan", text: "Calm, composed and a skilled fighter. You'd do anything for the people you love.", traits: { loyal: 2, bold: 2, elegant: 1 }, colors: ["#1b1b1f", "#f2f0ea", "#6b5b5b"] },
  { name: "Ei Gyoumei", title: "The Crown Prince", text: "Proud and powerful, with a heart that only opens for a special few.", traits: { proud: 3, loyal: 1, elegant: 1 }, colors: ["#7b2cbf", "#e9b949", "#f2f0ea"] },
  { name: "Shin-u", title: "Captain of the Eagle Eyes", text: "Cool and quiet, until something truly delights you. Then that rare smile appears.", traits: { mysterious: 2, loyal: 2, bold: 1 }, colors: ["#1b1b1f", "#2b2d6e", "#a0d2ff"] },
  { name: "Leelee", title: "Keigetsu's attendant", text: "Snarky, honest and fiercely devoted once someone earns your trust.", traits: { loyal: 2, fierce: 1, cheerful: 1 }, colors: ["#ff6f61", "#ffd166", "#f2f0ea"], image: "/img/iv/leelee.jpg" },
  { name: "Kou Tousetsu", title: "Reirin's devoted lady-in-waiting", text: "Steady, protective and completely loyal. Nobody hurts your lady on your watch.", traits: { loyal: 3, clever: 1, fierce: 1 }, colors: ["#2b2d6e", "#fff8e7", "#ffd166"] },
  { name: "Kou Kenshuu", title: "The Empress", text: "Strong-willed, wise and kind. You lead with a quiet strength everyone respects.", traits: { kind: 1, bold: 2, elegant: 1, proud: 1 }, colors: ["#e9b949", "#c1121f", "#fff8e7"] },
];

export const IV = createQuiz({ traits, bank, characters });

export const IV_PAIRS = [
  ["Kou Reirin", "Shu Keigetsu"], ["Kou Reirin", "Shin-u"], ["Kou Reirin", "Ei Gyoumei"],
  ["Shu Keigetsu", "Leelee"], ["Kou Reirin", "Kou Tousetsu"], ["Kin Seika", "Ran Houshun"],
];
